import React, { createContext, useContext } from 'react';

import { FormInstance } from 'antd/es/form';

type EditDataModalContentType = {
  form?: FormInstance;
  modified: boolean;
  loading: boolean;
  setModified: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  onSuccess: (data?: any) => void;
};

export const EditDataModalContext = createContext<EditDataModalContentType>({
  form: undefined,
  modified: false,
  loading: false,
  setModified: () => {
    // Do Nothing
  },
  setLoading: () => {
    // Do Nothing
  },
  onSuccess: () => {
    // Do Nothing
  },
});

export const useEditDataModalContext = () => useContext(EditDataModalContext);
